import React, { Fragment, FunctionComponent, ReactNode, useEffect, useState } from 'react';
import "./transactionDetails.scss"
import { useHistory } from 'react-router-dom';
import { MenuItem } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';

import { IAccountType, TransactionState } from '../../core/reducers/transactionDetailsReducer';
import {
  CURRENCY,
  EMAILID,
  INCORRECT_ACCOUNT_FORMAT,
  INCORRECT_SOURCE_OF_FUNDS,
  INCORRECT_REMITANCE_AMOUNT,
  LIMIT_EXCEEDED,
  NAME,
  OTHER_SOURCE_OF_FUNDS_HELPER_TEXT,
  PAN,
  PROCEED,
  PURPOSE_OF_REMITTANCE,
  REFERENCEID,
  REFERENCEID_TOOLTIP_TEXT,
  REMITTANCE_AMOUNT,
  REMITTANCE_AMOUNT_HELPER_TEXT,
  SELECT_ACC_NO,
  SOURCE_OF_FUNDS,
  SOURCE_OF_FUNDS_ITEMS,
  SOURCE_OF_FUNDS_PLACEHOLDER,
  TRANSACTION_DETAILS_HEADING,
  TRANSACTION_VINTAGE_MESSAGE,
  USER_DOB,
  USER_NAME,
  REMITTER_NAME_HELPER_TEXT
} from '../../constants/messages';
import { RI_PURPOSE_CODE } from '../../constants/constants';
import Select from '../../components/select/select';
import Tooltip from '../../components/tooltip/tooltip';
import Text from '../../components/typography/typgraphy';
import TextInput from '../../components/textInput/textInput';
import AxisButton from '../../components/button/button';
import rightTick from "../../assets/images/righttick.svg";
import tooltipDark from "../../assets/images/tooltipDark.svg";
import tooltipLight from "../../assets/images/tooltipLight.svg";
import { amountWithCommas, crypt, decrypt, getTransactionIdFromURL } from '../../constants/utils';
import { APP_URLS, ARGO_SUCCESS, ERROR_CODES } from '../../constants/constants';
import { IErrorResponseType, ISubmitPaymentConsent, ISuccessResponseType } from '../../constants/commonTypes';
import Loader from '../../components/loader/loader';
import { pushDataLayer, TRANSACTION_DETAILS_PAGELOAD_PARAM, TRANSACTION_DETAILS_PROCEED, TRANSACTION_DETAILS_PAGELOAD_VPV, TRANSACTION_DETAILS_SOF, SAFE_USAGE_CLICK_GA, SAFE_USAGE_GA, TAX_DECLARATION_GA } from '../../constants/gaConstants';
import { AuthState } from '../../core/reducers/authReducer';
import Checkbox from '../../components/checkbox/checkbox';
import Card from '../../components/cards/card';
import { tax } from './taxVerificationHtml';
import { UploadDetailsState } from "../../core/reducers/uploadDocumentReducer";
import { useSelector } from 'react-redux';	
import SafeUsageModal from '../safeUsageGuidelines/safeUsageModal';
interface ITransactionDetailsProps {
  transactionDetails: TransactionState;
  isLoading: boolean;
  isAuthenticated: boolean;
  inAppBackPressed: boolean;
  children?: ReactNode;
  consentResponse: ISuccessResponseType;
  errorTransactionDetails: IErrorResponseType;
  errorSubmitConsent: IErrorResponseType;
  submittedConsent: ISubmitPaymentConsent;
  partnerData: AuthState;
  submitConsent(request: ISubmitPaymentConsent): void;
  getTransactionDetails(): void;
  resetSubmitConsent(): void;
  resetTransactionSummary(): void;
  getTaxDetails(): void;
  getUploadDetails():void;
  errorTaxDetails: IErrorResponseType;
  uploadDetailsResponse: UploadDetailsState;
}

const TransactionDetails: FunctionComponent<ITransactionDetailsProps> = (props) => {
  const {
    consentResponse,
    transactionDetails,
    errorTransactionDetails,
    errorSubmitConsent,
    isLoading,
    isAuthenticated,
    inAppBackPressed,
    submittedConsent,
    partnerData,
    getTransactionDetails,
    submitConsent,
    resetSubmitConsent,
    resetTransactionSummary,
    getTaxDetails,
    getUploadDetails,
    errorTaxDetails,
    uploadDetailsResponse
  } = props;
  const txnId = getTransactionIdFromURL()
  const history = useHistory();
  const sugContent = useSelector(state => state.safeUsage);

  // State Varaibles
  const [data, setData] = useState({} as TransactionState)
  const [openTooltip, setOpenTooltip] = useState(false)

  const [accountNumber, setAccountNumber] = useState({} as IAccountType)
  const [accountFormatError, setAccountFormatError] = useState(false)

  const [sourceOfFunds, setSourceOfFunds] = useState(-1)
  const [otherSourceOfFunds, setOtherSourceOfFunds] = useState('')
  const [sourceOfFundsError, setSourceOfFundsError] = useState(false)

  const [finalRemittanceAmt, setFinalRemittanceAmt] = useState(0)
  const [remittanceLimitError, setRemittanceLimitError] = useState(false)
  const [remittanceAmountError, setRemittanceAmountError] = useState(false)

  const [proceedError, setProceedError] = useState(false)
  const [proceedClicked, setProceedClicked] = useState(false)

  const [isValidVintage, setIsValidVintage] = useState(true)
  const [isUploadSaved, setIsUploadSaved] = useState(false)
  const [isChecked, setIsChecked] = useState(false)

  const [isSafeUsageChecked, setIsSafeUsageChecked] = useState(false)	
  const [openModal, setOpenModal] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const [userPanName, setUserPanName] = useState('');

  // GA on page load
  useEffect(() => {
    pushDataLayer(TRANSACTION_DETAILS_PAGELOAD_VPV(partnerData.customerId, txnId))
    pushDataLayer(TRANSACTION_DETAILS_PAGELOAD_PARAM(partnerData.customerId, txnId))
  }, [partnerData.customerId, txnId])

  /**
   * Redirect to Error Page if any error comes while fetching the Transaction Details or Submitting the Transaction Consent
   */
  useEffect(() => {
    if (errorTransactionDetails) {
      let exceptionError = Object.values(ERROR_CODES.EXCEPTIONS).includes(errorTransactionDetails.code);
      if (!exceptionError) {
        history.push({
          pathname: `${APP_URLS.ERROR.replace(":txnId", txnId)}`,
          state: {
            errorCode: errorTransactionDetails.code,
            partnerName: partnerData.partnerName !== "" ? partnerData.partnerName : null
          }
        })
      }
    }
  }, [errorTransactionDetails, history, txnId, partnerData])

  useEffect(() => {
    if (errorSubmitConsent) {
      let exceptionError = Object.values(ERROR_CODES.EXCEPTIONS).includes(errorSubmitConsent.code);
      if (!exceptionError) {
        history.push({
          pathname: `${APP_URLS.ERROR.replace(":txnId", txnId)}`,
          state: {
            errorCode: errorSubmitConsent.code,
            partnerName: partnerData.partnerName !== "" ? partnerData.partnerName : null
          }
        })
      }
      else {
        switch (errorSubmitConsent.code) {
          case ERROR_CODES.EXCEPTIONS.ACCOUNT_FORMAT_EXCEPTION:
            setAccountFormatError(true)
            break;
          case ERROR_CODES.EXCEPTIONS.REMITANCE_AMOUNT_EXCEPTION:
            setRemittanceAmountError(true)
            break;
          case ERROR_CODES.EXCEPTIONS.SOURCE_OF_FUNDS_EXCEPTION:
            setSourceOfFundsError(true)
            break;
          default:
            break;
        }
      }
    }
  }, [errorSubmitConsent, history, txnId, partnerData])


  /**
   * Redirect to Error Page if any error comes while fetching the Tax Details
   */
   useEffect(() => {
    if (errorTaxDetails) {
      history.push({
        pathname: `${APP_URLS.ERROR.replace(":txnId", txnId)}`,
        state: {
          errorCode: errorTaxDetails.code,
          partnerName: partnerData.partnerName !== "" ? partnerData.partnerName : null
        }
      })
    }
  }, [errorTaxDetails, history, txnId, partnerData])


  /**
   * Reset In App Back Button Pressed Action, retain data and reset the Submit Transaction Consent
   */
  useEffect(() => {
    if (inAppBackPressed && submittedConsent && Object.keys(submittedConsent).length !== 0 && submittedConsent.constructor === Object) {
      setData(transactionDetails)
      const indexOfSourceOfFunds = SOURCE_OF_FUNDS_ITEMS.indexOf(submittedConsent.funds.source)
      setSourceOfFunds(indexOfSourceOfFunds)
      setOtherSourceOfFunds(submittedConsent.funds.desc)
      setUserPanName(submittedConsent.userName? decrypt(submittedConsent.userName, txnId): submittedConsent.userName)
      if (data.accNumbers && data.accNumbers.length > 0) {
        let currentAcc = data.accNumbers.filter((val) => {
          return val.maskedAcc === submittedConsent.finalAccNo
        })
        setAccountNumber(currentAcc[0])
        setIsValidVintage(currentAcc[0].isValidVintage)
      }
      /**
       * ARGO 509: Account should not be editable if document is uploaded
       * for ETB < 12 months
       */
      if (uploadDetailsResponse && uploadDetailsResponse.fileList && uploadDetailsResponse.fileList.length) {
        setIsUploadSaved(true)
      }
      setFinalRemittanceAmt(submittedConsent.finalRemittanceAmt)
      resetSubmitConsent();
      resetTransactionSummary();
    }
  }, [inAppBackPressed, transactionDetails, sourceOfFunds, otherSourceOfFunds, accountNumber, finalRemittanceAmt, data.accNumbers, submittedConsent, resetSubmitConsent, resetTransactionSummary, uploadDetailsResponse])

  useEffect(() => {
    if(consentResponse.code === ARGO_SUCCESS && proceedClicked){
      if ( !isValidVintage ) {
        // Success
        history.push(`${APP_URLS.DOCUMENT_UPLOAD.replace(":txnId", txnId)}`);
      }
      else if ( !inAppBackPressed ) {
        // Success
        history.push(`${APP_URLS.TRANSACTION_SUMMARY.replace(":txnId", txnId)}`);
      }
    }
  }, [consentResponse, history, txnId, inAppBackPressed, proceedClicked, isValidVintage])

  /**
  * Get Transaction details
  */
  useEffect(() => {
    function getDetails() {
      getTransactionDetails()
    }
    if (isAuthenticated && !transactionDetails.transactionDetailsFetched) {
      getDetails()
    }
  }, [isAuthenticated, getTransactionDetails, transactionDetails])

  // useEffect(() => {
  //   if(props.transactionDetails.accNumbers.length){
  //     if(!props.transactionDetails.accNumbers[0].isValidVintage)
  //     pushDataLayer(COMMON_GA(txnId, "", "" , "ETB<12 months"))
  //   else{
  //     pushDataLayer(COMMON_GA(txnId, "", "" , "ETB>12 months"))
  //   }
  // }
  // },[props.transactionDetails])

  /**
   * Set transaction details to state
   */
  useEffect(() => {
    if (inAppBackPressed) return;
    setData(transactionDetails)
    if (data.accNumbers && data.accNumbers.length > 0) {
      let activeAccount = data.accNumbers.filter((val) => {
        return val.isActive === true
      })
      if (activeAccount.length > 0) {
        setAccountNumber(activeAccount[0])
        setIsValidVintage(activeAccount[0].isValidVintage)
      }
    }
    if (finalRemittanceAmt === 0) {
      setFinalRemittanceAmt(transactionDetails.amount)
    }
    if (!accountNumber && data.activeAccount !== null && data.activeAccount !== "") {
      setAccountNumber(data.activeAccount)
    } else if (!accountNumber){
      setAccountNumber("")
    }
  }, [transactionDetails, finalRemittanceAmt, data.activeAccount, inAppBackPressed, data.accNumbers, data.accNumbers])

  /**
  * Get Tax file content
  */
   useEffect(() => {
    function getDetails() {
      !transactionDetails.fileContent && getTaxDetails()
    }
    setIsLoad(true)
    /**
     * For NRE customer, tax declaration is not applicable hence
     * no API call and tax section should be hidden in UI, purpose code is
     * used to determine NRE or RI (resident indian)
     */
    if (isAuthenticated && transactionDetails.transactionDetailsFetched && transactionDetails.purposeCode === RI_PURPOSE_CODE && (!transactionDetails.fileContent || transactionDetails.fileContent.length <= 0)) {
      getDetails()
    }
  }, [isAuthenticated, getTaxDetails, transactionDetails])

  /**
  * Get upload concent file content
  */
  useEffect(() => {
    function getDetails() {
      isLoad && getUploadDetails()
      setIsLoad(false)
    }
    /**
     * For NRE customer, tax declaration is not applicable hence
     * no API call and tax section should be hidden in UI, purpose code is
     * used to determine NRE or RI (resident indian)
     */
    if (isAuthenticated && transactionDetails.transactionDetailsFetched && transactionDetails.purposeCode === RI_PURPOSE_CODE && transactionDetails.fileContent && (!transactionDetails.uploadFileContent || transactionDetails.uploadFileContent.length <= 0)) {
      getDetails()
    }
  }, [isAuthenticated, getUploadDetails, transactionDetails, isLoad])

  /**
   * Check if the Remittance Amount is not greater than the limit
   */
  useEffect(() => {
    if (data.limit && (finalRemittanceAmt > data.limit)) {
      setRemittanceLimitError(true)
    } else {
      setRemittanceLimitError(false)
    }
  }, [data, finalRemittanceAmt])


  /**
   * Update the Remittance Amount
   * Only allow numbers and truncate the preceeding 0s
   * @param e Event
   */
  const onAmountChange = (e: any) => {
    const regex = /^[0-9]*\.?[0-9]{0,2}$/;
    if (e.target.value === '' || regex.test(e.target.value)) {
      let value = e.target.value.replace(/^0+/, '');
      setFinalRemittanceAmt(value)
      if(value < 1 || value === '.'){
        setRemittanceAmountError(true)
      } else {
        setRemittanceAmountError(false)
      }
    }
  }

  /**
   * Update Account Number state by its index from the transaction details array
   * @param e Event
   */
  const onAccountNumberChange = (e: any) => {
    let currentAcc = data.accNumbers.filter((val) => {
      return val.maskedAcc === e.target.value
    })
    setAccountNumber(currentAcc[0])
    setIsValidVintage(currentAcc[0].isValidVintage)
  }

  /**
   * Update Source of Funds state by its index from the constant array
   * @param e Event
   */
  const onSourceOfFundsChange = (e: any) => {
    pushDataLayer(TRANSACTION_DETAILS_SOF(partnerData.customerId, finalRemittanceAmt, txnId, transactionDetails.purposeCode, SOURCE_OF_FUNDS_ITEMS[sourceOfFunds]))
    if (e.target.value !== 4) {
      setOtherSourceOfFunds('')
    }
    setSourceOfFunds(e.target.value)
  }

  /**
   * Update Other Source of Funds state text
   * @param e Event
   */
  const onOtherSourceOfFundsChange = (e: any) => {
    const notAllowedChar: RegExp = /[,!#%\?&\$\^~`\(\)\*"<>'@]/;
    if (e.target.value.length <= 28 && !notAllowedChar.test(e.target.value)) {
      setOtherSourceOfFunds(e.target.value)
    }
  }

  /**
   * Update Remitter Name state text
   * @param e Event
   */
  const onUserPanNameChange = (e: any) => {
    const nameRegex: RegExp = /^[a-zA-Z]+(([a-zA-Z. ])*[a-zA-Z\.]*)*$/;
    if (e.target.value.length <= 85 && nameRegex.test(e.target.value)) {
      setUserPanName(e.target.value)
    }
    else if(e.target.value == ''){
      setUserPanName('')
    }
  }
  
  /** 
   * Validate all fields to proceed to summary screen
   * 
   * 1. Check the source of funds are valid - Other Source of Funds should not be empty (If applicable)
   * 2. The Remittance Amount should be less than the limit
   * 3. If the ActiveAccount is false, then default account number should not be selected
   * 4. If tax declaration and safe usage is checked
   * 5. Remitter Name should not be empty
   */
  useEffect(() => {
    if (sourceOfFunds === 4 && otherSourceOfFunds === "") {
      setProceedError(true)
    }
    else if (remittanceLimitError || remittanceAmountError || sourceOfFunds === -1) {
      setProceedError(true)
    } 
    else if (accountNumber.maskedAcc === undefined) {
      setProceedError(true)
    } 
    else if (userPanName === "") {
      setProceedError(true)
    }
    else if (isSafeUsageChecked === false) {
      setProceedError(true)
    }
    else if(transactionDetails.purposeCode === RI_PURPOSE_CODE){	
      if( isChecked){	
        setProceedError(false)	
      }	
      else {	
        setProceedError(true)	
      }	
    }	
    
    else {	
      setProceedError(false)	
    }	
  }, [remittanceLimitError, sourceOfFunds, otherSourceOfFunds, accountNumber, remittanceAmountError,isChecked, isSafeUsageChecked, transactionDetails.purposeCode, userPanName])

  /**
   * Submit transaction details consent and proceed to summary screen
   */
  const onProceed = async () => {
    pushDataLayer(TRANSACTION_DETAILS_PROCEED(partnerData.customerId, finalRemittanceAmt, txnId, transactionDetails.purposeCode, SOURCE_OF_FUNDS_ITEMS[sourceOfFunds]))
    let req = {
      funds: {
        source: SOURCE_OF_FUNDS_ITEMS[sourceOfFunds],
        desc: otherSourceOfFunds
      },
      finalAccNo: accountNumber.maskedAcc,
      finalRemittanceAmt: finalRemittanceAmt,
      taxDeclarationVersion: data.purposeCode == RI_PURPOSE_CODE ? data.version: "",
      safeUsageVersion: "safe_usage_1.0.1",
      userName: crypt(userPanName, txnId),
      userDOB: crypt(data.userDOB.split('-').join('/'), txnId),
    }
    await submitConsent(req);
    setProceedClicked(true)
  }

  const handleCheckboxClick = () => {
    pushDataLayer(TAX_DECLARATION_GA(partnerData.customerId, finalRemittanceAmt, txnId, transactionDetails.purposeCode, SOURCE_OF_FUNDS_ITEMS[sourceOfFunds]))
    setIsChecked(!isChecked)
  }
  const handleCheckClick = () => {
    pushDataLayer(SAFE_USAGE_GA(partnerData.customerId, finalRemittanceAmt, txnId, transactionDetails.purposeCode, SOURCE_OF_FUNDS_ITEMS[sourceOfFunds]))	
    setIsSafeUsageChecked(!isSafeUsageChecked)	
  }	
  const onSafeUsageClick = () => {	
    pushDataLayer(SAFE_USAGE_CLICK_GA(partnerData.customerId, finalRemittanceAmt, txnId, transactionDetails.purposeCode, SOURCE_OF_FUNDS_ITEMS[sourceOfFunds]))
    setOpenModal(true)	
  }
  return (
    <Fragment>
      {isLoading && <Loader />}
      <div className="transaction-details-container">
        <div className="details-wrapper">
          <div className="details-container">
            <Text fontSize={20} fontWeight={700} className="details-heading">{TRANSACTION_DETAILS_HEADING}</Text>
            <div className="details-content">
              <div className="details-item-tooltip">
                <div className="details-item-wrapper">
                  <Text fontSize={12} className="item">{REFERENCEID}</Text>
                  <Text className="item text-uppercase">{data.referenceNumber}</Text>
                </div>
                <Tooltip
                  open={openTooltip}
                  onOpen={() => setOpenTooltip(true)}
                  onClick={() => setOpenTooltip(!openTooltip)}
                  onClose={() => setOpenTooltip(false)}
                  className="tooltip"
                  content={REFERENCEID_TOOLTIP_TEXT(data.partnerName)}>
                  {
                    openTooltip
                      ? <img className="tooltip-icon" src={tooltipDark} alt="tooltip" />
                      : <img className="tooltip-icon" src={tooltipLight} alt="tooltip" />
                  }
                </Tooltip>
              </div>
              <div className="details-item">
                <Text fontSize={12} className="item">{NAME}</Text>
                <Text className="item">{data.userName}</Text>
              </div>
              <div className="details-item">
                <Text fontSize={12} className="item">{PAN}</Text>
                <Text className="item">{data.pan}</Text>
              </div>
              <div className="details-item-amount-wrapper">
              <div className="details-item">
                <Text fontSize={12} className="item">{EMAILID}</Text>
                <Text className="item">{data.emailId}</Text>
              </div>
              <Text fontSize={12} className={"helper-text"}>{`Email id as registered with ${data.partnerName}`}</Text>
              </div>
              <div className="details-item">
                <Text fontSize={12} className="item">{PURPOSE_OF_REMITTANCE}</Text>
                <Text className="item">{data.purposeCode}</Text>
              </div>
              <div className="details-item">
                <Text fontSize={12} className="item">{CURRENCY}</Text>
                <Text className="item">{data.currency}</Text>
              </div>
              <div className="details-item">
                <Text fontSize={12} className="item">{USER_DOB}</Text>
                <Text className="item">{data.userDOB? data.userDOB.split('-').join('/'):data.userDOB}</Text>
              </div>

              {/*Disabled amount field  */}
              <div className="details-item">
                <Text fontSize={12} className="item">{REMITTANCE_AMOUNT}</Text>
                <Text className="item">{finalRemittanceAmt}</Text>
              </div>

              <div className="details-item-amount-wrapper">
                {/* <div className="source-of-funds"> */}
                  <div className="details-item white-bg remitance-amount">
                    <Text fontSize={12} className="item">{USER_NAME}<span className="required">*</span></Text>
                    <TextInput
                      fullWidth={true}
                      value={userPanName}
                      handleOnChange={(e) => onUserPanNameChange(e)}
                      customStyle="item-input"
                    />
                  </div>
                {/* </div> */}
                <Text className={"helper-text"}>{REMITTER_NAME_HELPER_TEXT}</Text>
              </div>
              
              {/* TODO: Due to compliance pointer, amount field is made disabled. amount received from partner will be kept as it is */}
              {/* <div className="details-item-amount-wrapper">
                <div className="details-item white-bg remitance-amount">
                  <Text fontSize={12} className="item">{REMITTANCE_AMOUNT}<span className="required">*</span></Text>
                  <TextInput fullWidth={true} value={finalRemittanceAmt} handleOnChange={(e) => onAmountChange(e)} customStyle="item-input" />
                </div>
                {data.limit ? (remittanceLimitError
                  ? <Text fontSize={14} className={"error-text"}>{LIMIT_EXCEEDED(amountWithCommas(data.limit), data.currency)}</Text>
                  : <Text fontSize={14} className={"helper-text"}>{REMITTANCE_AMOUNT_HELPER_TEXT(amountWithCommas(data.limit), data.currency)}</Text>) : ''}
                {remittanceAmountError && <Text className={"error-text"}>{INCORRECT_REMITANCE_AMOUNT}</Text>}
              </div> */}
              <div className="details-item-amount-wrapper">
                <div className={data.freezeFlag ? "details-item" : "details-item white-bg"}>
                  <Text fontSize={12} className="item">{SELECT_ACC_NO}<span className="required">*</span></Text>
                  <Select
                    className="item-dropdown"
                    value={accountNumber.maskedAcc}
                    onChange={onAccountNumberChange}
                    disabled={data.freezeFlag || (!isValidVintage && isUploadSaved)}
                  >
                    <MenuItem className="select-placeholder" value={""} disabled>
                      Select
                    </MenuItem>
                    {
                      data.accNumbers
                        ? data.accNumbers.map((item: IAccountType, index: number) => {
                          return (
                            <MenuItem value={item.maskedAcc} key={index}>
                              {item.maskedAcc}
                              {
                                accountNumber === item
                                  ? <img className="selected-item" src={rightTick} alt="selected" />
                                  : null
                              }
                            </MenuItem>
                          )
                        })
                        : null
                    }
                  </Select>
                </div>
                {accountFormatError && <Text className={"error-text"}>{INCORRECT_ACCOUNT_FORMAT}</Text>}
                {!isValidVintage && <Text fontSize={12} className={"helper-text"}>{TRANSACTION_VINTAGE_MESSAGE}</Text>}
              </div>
              <div className="details-item-amount-wrapper">

                <div className="details-item white-bg">
                  <Text fontSize={12} className="item">{SOURCE_OF_FUNDS}<span className="required">*</span></Text>
                  <Select
                    className="item-dropdown"
                    value={sourceOfFunds}
                    onChange={onSourceOfFundsChange}
                  >
                    <MenuItem className="select-placeholder" value={-1} disabled>
                      Select
                    </MenuItem>
                    {
                      SOURCE_OF_FUNDS_ITEMS.map((item: string, index: number) => {
                        return (
                          <MenuItem value={index} key={index}>
                            {item}
                            {
                              sourceOfFunds === index ?
                                <img className="selected-item" src={rightTick} alt="selected" />
                                : null
                            }
                          </MenuItem>
                        )
                      })
                    }
                  </Select>
                </div>
                {sourceOfFundsError && <Text className={"error-text"}>{INCORRECT_SOURCE_OF_FUNDS}</Text>}
              </div>
              
                {
              sourceOfFunds === 4 ?
              <div className="details-item-amount-wrapper">
                <div className="source-of-funds">
                  <div className="details-item">
                    <TextInput
                      fullWidth={true}
                      value={otherSourceOfFunds}
                      placeholder={SOURCE_OF_FUNDS_PLACEHOLDER}
                      handleOnChange={(e) => onOtherSourceOfFundsChange(e)}
                      customStyle="item-input"
                    />
                  </div>
                </div>
                <Text className={"helper-text"}>{OTHER_SOURCE_OF_FUNDS_HELPER_TEXT}</Text>
              </div>
              : null
            }
            </div>
          </div>
        </div>
          	
        <div className={`safe-usage ${transactionDetails.purposeCode !== RI_PURPOSE_CODE?`sf-no-notice`:``}`}>	
          <div className="safe-usage__checkbox">	
            <Checkbox onChange={handleCheckClick}  required={true} checked={isSafeUsageChecked}/>	
          </div>	
          <div className="safe-usage__text">I have read and understood <a onClick={() => onSafeUsageClick()} className="safe-usage-text-link">Safe Usage Guidelines</a></div>	
        </div>

        {
          transactionDetails.purposeCode === RI_PURPOSE_CODE ? 
        <div className="tax-container">
          <Card>
            <div className="tax-wrapper">
              <div className="tax-body">
                <div className="checkbox">
                  <Checkbox onChange={handleCheckboxClick} required={true} checked={isChecked} /> 
                </div>
                <div className="tax-body-text">
                  <div dangerouslySetInnerHTML={{ __html: data.fileContent }} />  
                </div>
              </div>
              <div className="tax-note">
                <InfoIcon className="note-icon"/>
                <Text className="tax-note-text">Note: In case these conditions are not met we cannot proceed with this transaction.</Text>
              </div>
            </div>
          </Card>
        </div>: null
        }
        <div className="submit-btn-container">
          <AxisButton onClick={() => onProceed()} disabled={proceedError} disableElevation customStyle={"submit-btn-primary"} variant="contained">
            <Text className={"submit-btn-text"}>{PROCEED}</Text>
          </AxisButton>
        </div>
        {openModal && <SafeUsageModal setOpenModal={setOpenModal} openModal={openModal} />}
      </div>
    </Fragment >
  )
}

export default TransactionDetails;